import React from 'react';
import { useNavigate } from 'react-router-dom';

function FicheDescriptiveProfessional({ professional }) {
  const navigate = useNavigate();

  if (!professional) {
    return <p>Aucun professionnel sélectionné.</p>;
  }

  return (
    <div style={{
      border: '1px solid #ccc',
      borderRadius: '10px',
      padding: '20px',
      marginBottom: '30px',
      backgroundColor: '#fafafa',
      maxWidth: '700px'
    }}>
      {professional.photo_url && (
        <img
          src={professional.photo_url}
          alt={`${professional.first_name} ${professional.last_name}`}
          style={{ width: '120px', height: '120px', objectFit: 'cover', borderRadius: '50%' }}
        />
      )}

      <h2 style={{ marginTop: '10px' }}>{professional.first_name} {professional.last_name}</h2>

      <p><strong>Spécialités :</strong> {professional.specialities?.join(', ') || 'Non spécifiées'}</p>
      <p><strong>Services offerts :</strong> {professional.services?.join(', ') || 'Non spécifiés'}</p>
      <p><strong>Mode(s) de service :</strong> {professional.modes?.join(', ') || 'Non spécifié'}</p>
      <p><strong>Description :</strong> {professional.description || 'Aucune description disponible.'}</p>
      <p><strong>Langues parlées :</strong> {professional.languages?.join(', ') || 'Non spécifiées'}</p>
      <p><strong>Appartenance(s) culturelle(s) :</strong> {professional.cultures?.join(', ') || 'Non spécifiées'}</p>
      <p><strong>Zone géographique desservie :</strong> {professional.zone_name || 'Non précisée'}</p>

      <button
        style={{
          marginTop: '15px',
          backgroundColor: '#6a1b9a',
          color: 'white',
          padding: '10px 15px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
        onClick={() => navigate(`/prendre-rendez-vous/${professional.user_id}`)}
      >
        Prendre rendez-vous
      </button>
    </div>
  );
}

export default FicheDescriptiveProfessional;